export const grApiRoot = 'https://uqh87q11i5.execute-api.us-east-1.amazonaws.com/prod'
